module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "capitalRecord"
  }, [_c('div', {
    staticClass: "content"
  }, [(_vm.customerPreSaveSerials && _vm.customerPreSaveSerials.length > 0) ? _c('div', [_vm._l((_vm.customerPreSaveSerials), function(item, index) {
    return _c('xk-capital-record-list', {
      key: index,
      attrs: {
        "time": _vm.$utils.TimestampDate(item.time),
        "sum": item.cost ? item.cost.toFixed(1) : 0,
        "type": item.style
      },
      on: {
        "click": function($event) {
          return _vm.actionFn(item.memo)
        }
      }
    })
  }), _vm._v(" "), (_vm.capitalRecords.content.length < _vm.capitalRecords.totalElements) ? _c('div', {
    staticClass: "queryList",
    on: {
      "click": _vm.loadButFn
    }
  }, [_c('span', [_vm._v("加载更多信息")])]) : _vm._e()], 2) : _c('div', {
    staticClass: "zanwujilv"
  }, [_c('h2', [_vm._v("暂无资金流水记录")])])]), _vm._v(" "), _c('xk-upload-mod', {
    attrs: {
      "state": _vm.loadState
    }
  }), _vm._v(" "), (_vm.text !== '') ? _c('xk-alert-box', {
    attrs: {
      "text": _vm.text
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5af4764d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mewallet/capitalRecord/capitalRecord.vue
// module id = 534
// module chunks = 0